// import { TableStructure } from '~components/TableComponent/types';
import { defineStore } from 'pinia';
// eslint-disable-next-line import/no-cycle
import Api from '~utils/Api';
// eslint-disable-next-line import/no-cycle
import { useMainStore } from '~store/index';
// eslint-disable-next-line import/no-cycle
import { useAuthStore } from '~store/auth/authModule';
// eslint-disable-next-line import/no-cycle
import { useOrgsStore } from '~store/orgs/orgsModule';
// eslint-disable-next-line import/no-cycle
import { usePatientStore } from '~store/patient/patientModule';
import {
  saveSelectedNodes,
  saveTreeNode,
  restoreSelectedNodesIds,
  clearTreeState,
} from '~utils/statePersistence';
import {
  TreeItem,
  StaffItem,
  TreeNode,
  SearchParams,
} from './types';

export const useTreeStore = defineStore('tree', {
  state: () => ({
    tree: null as any | TreeItem[],
    staffList: [] as any | StaffItem[],
    treeNode: '0' as string,
    selectedNodesMap: [] as TreeNode[],
    actualPatients: [] as any[],
    actualPatientsLength: null as number | null,
    nodeProcessing: false,
    underControl: null as any,
    pagin: {
      p_start: 0,
      p_lenght: 50,
    },
    patientSearch: '' as string,
    idPatientSearch: null as number | null,
    contractSearch: null as number | null,
  }),
  getters: {},
  actions: {
    async restoreTreeState(): Promise<void> {
      const authStore = useAuthStore();
      const orgsStore = useOrgsStore();
      const userId = authStore.currentUser?.id_login;
      if (!userId) return;

      const currentOrgId = orgsStore.currentOrg;
      const restoredIds = restoreSelectedNodesIds(userId, currentOrgId);

      if (!restoredIds.length) return;

      this.selectedNodesMap = [];
      this.treeNode = '0';

      await this.getOrgTreePart();

      // eslint-disable-next-line no-restricted-syntax
      for (const targetId of restoredIds) {
        const currentLevel = this.tree || [];
        const found = currentLevel.find((node: any) => String(node.id_tree) === String(targetId));
        if (!found) {
          console.warn(`Не удалось найти узел ${targetId} на уровне ${this.treeNode}`);
          break;
        }

        this.selectedNodesMap.push({
          id_tree: found.id_tree,
          nodeEntries: currentLevel,
        });

        this.treeNode = targetId;
        // eslint-disable-next-line no-await-in-loop
        await this.getOrgTreePart();
      }

      if (restoredIds.length > 0) {
        this.treeNode = restoredIds[restoredIds.length - 1];
      }

      saveSelectedNodes(this.selectedNodesMap, userId, currentOrgId);
      saveTreeNode(this.treeNode, userId, currentOrgId);

      console.log('Восстановлено:', {
        ids: restoredIds,
        mapLength: this.selectedNodesMap.length,
        finalTreeNode: this.treeNode,
      });
    },
    isNodeMapLoaded() {
      return this.selectedNodesMap.length;
    },
    checkInputType(value: string) {
      if (value === '') {
        return '';
      }
      const num = Number(value);
      return Number.isNaN(num) || value.trim() !== value ? 'string' : 'number';
    },

    async getOrgTreePart(searchPath = false): Promise<void | boolean> {
      const params = {
        Name_event: 'GET:tree_v2',
        Name_module: 'WEB_managers',
        id_tree: this.treeNode,
        id_org: useOrgsStore().currentOrg ?? 0,
        ...useMainStore().getConstantParams,
      };
      try {
        this.nodeProcessing = true;
        const result = await Api.get(params);
        if (!result.errorType) {
          const { data } = result;
          if (data) {
            this.tree = data;

            const nodeExists = this.selectedNodesMap.some(
              (node) => node.id_tree === this.treeNode,
            );
            if (!nodeExists) {
              this.selectedNodesMap.push({
                id_tree: this.treeNode,
                nodeEntries: this.tree,
              });
              const userId = useAuthStore().currentUser.id_login;
              const orgId = useOrgsStore().currentOrg;
              saveSelectedNodes(this.selectedNodesMap, userId, orgId);
              saveTreeNode(this.treeNode, userId, orgId);
            }
            usePatientStore().getContractsMatrix(this.treeNode);
            this.getActualPatients(false, true);
          }
          if (searchPath) {
            return true;
          }
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.nodeProcessing = false;
      }
      return false;
    },

    async getTreeStaffList(search_string = '', type_drop = 0): Promise<void> {
      if (this.treeNode === '' || !this.selectedNodesMap.length) {
        return;
      }
      const params = {
        Name_event: 'GET:tree_staff_list',
        Name_module: 'WEB_managers',
        search_string,
        type_drop,
        // eslint-disable-next-line no-nested-ternary
        id_tree: this.treeNode !== '0' ? this.treeNode : this.selectedNodesMap[0].nodeEntries[0]?.id_tree,
        ...useMainStore().getConstantParams,
      };
      const result = await Api.get(params);
      if (!result.errorType) {
        const { data } = result;
        if (data) {
          data.forEach((i) => {
            const tmp = i?.id_patient ? JSON.parse(i?.id_patient) : 0;
            // eslint-disable-next-line no-param-reassign
            i.id_patient = tmp;
          });
          this.staffList = data;
          this.getActualPatients(false, true);
        }
      }
    },

    async getActualPatients(lazy = false, newNode = false): Promise<void> {
      if (
        (!useOrgsStore().currentOrg && !this.patientSearch)
      ) {
        return;
      }
      if (this.underControl) {
        this.underControl.abort();
      }
      if (newNode || this.patientSearch) {
        this.pagin.p_start = 0;
      }
      this.underControl = new AbortController();
      const { signal } = this.underControl;
      let searchParam = null;
      if (this.patientSearch) {
        searchParam = this.checkInputType(this.patientSearch.trim());
        if (searchParam === 'number') {
          this.idPatientSearch = parseInt(this.patientSearch, 10);
        }
      }
      const search_str: SearchParams = {
        fio: searchParam === 'string' ? this.patientSearch : '',
      };
      if (this.idPatientSearch) {
        search_str.id_patient = this.idPatientSearch;
      }
      const params: any = {
        Name_event: 'GET:patient_by_tree',
        Name_module: 'SmartPRO',
        id_org: useOrgsStore().currentOrg ?? 0,
        // eslint-disable-next-line no-nested-ternary
        // id_tree: (this.treeNode === '0' || !this.isNodeMapLoaded())
        //   ? this.treeNode : this.treeNode !== '0'
        // ? this.treeNode : this.selectedNodesMap[0].nodeEntries[0]?.id_tree,
        id_tree: this.treeNode,
        search_str: JSON.stringify({ ...search_str }),
        json_params: JSON.stringify({
          paging: {
            p_start: this.pagin.p_start,
            p_lenght: this.pagin.p_lenght,
            sort_type: 0,
          },
        }),
        ...useMainStore().getConstantParams,
      };
      if (this.contractSearch) {
        params.id_contract = this.contractSearch;
      }
      this.actualPatientsLength = null;
      try {
        const result = await Api.get(params, signal);
        if (!result.errorType) {
          const { data } = result;
          if (data) {
            const filtered = data.filter((i: any) => !!i.id_patient);
            if (lazy && (!newNode || this.patientSearch || this.idPatientSearch)) {
              this.actualPatients.push(...filtered);
              this.actualPatientsLength = data.length;
            } else if (!lazy && (newNode || this.patientSearch || this.idPatientSearch)) {
              this.actualPatients = filtered;
              this.actualPatientsLength = data.length;
            } else if (!lazy && !newNode) {
              this.actualPatients = filtered;
              this.actualPatientsLength = this.actualPatients.length;
            }
          }
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.idPatientSearch = null;
      }
    },

    setCurrentItem(item: string) {
      this.treeNode = item;
      const userId = useAuthStore().currentUser.id_login;
      const orgId = useOrgsStore().currentOrg;
      saveTreeNode(item, userId, orgId);
    },

    clearNodeMap(): void {
      this.selectedNodesMap = [];
      const userId = useAuthStore().currentUser.id_login;
      clearTreeState(userId);
    },

  },
});
